import React, { useState } from 'react';
import { Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaUser, FaLock, FaArrowRight, FaQuestionCircle } from 'react-icons/fa';
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBInput,
  MDBBtn,
  MDBSpinner
} from 'mdb-react-ui-kit';
import RadissonLogo from '../img/LogoBlancoRadisson.png';
import LOGOEBRO from '../img/LOGO-EBRO.png';
import { login } from '../utils/authService';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const data = await login(username, password);
      //navigate('/admin');
      navigate('/validarCheckInExpress', { replace: true });
      window.location.reload();
    } catch (error) {
      setShowErrorAlert(true);
      console.error('Login failed:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <MDBContainer fluid className="login-container p-0">
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      
      <MDBRow className="g-0 min-vh-100">
        {/* Left Panel - Radisson */}
        <MDBCol lg={4} className="d-none d-lg-flex left-panel align-items-center">
          <div className="w-100 p-5">
            <div className="text-center mb-5">
              <img
                src={RadissonLogo}
                alt="Logo Radisson"
                className="brand-logo mb-4"
                style={{ width: '220px' }}
              />
              <h3 className="mb-3 fw-bold">Bienvenido/a</h3>
              <p className="fs-5">
                Este portal está diseñado para que los colaboradores<br />
                gestionen check-ins y más.<br />
                ¡Gracias por su dedicación!
              </p>
            </div>
            
            <div className="d-flex justify-content-center mt-5">
              <div className="feature-item bg-white bg-opacity-10 p-3 rounded-3">
                <div className="d-flex align-items-center">
                  <div className="feature-icon me-3">
                    <FaUser className="fs-4" />
                  </div>
                  <span>Acceso exclusivo para colaboradores</span>
                </div>
              </div>
            </div>
          </div>
        </MDBCol>

        {/* Center Login Form - Now Wider */}
        <MDBCol lg={4} className="d-flex align-items-center justify-content-center p-5">
          <div className="login-form-container p-4 p-md-5 w-100" style={{ maxWidth: '500px' }}>
            <div className="text-center mb-4">
              <h2 className="fw-bold mb-3">Check-in Express</h2>
              <p className="text-muted fs-5">Ingrese sus credenciales para acceder</p>
            </div>

            {isLoading ? (
              <div className="text-center py-5">
                <MDBSpinner role="status" className="me-2" />
                <span>Verificando credenciales...</span>
              </div>
            ) : (
              <form onSubmit={handleLogin}>
                <div className="mb-4 position-relative">
                  <FaUser className="input-icon" />
                  <MDBInput
                    wrapperClass="mb-0"
                    label="Nombre de Usuario"
                    id="username"
                    type="text"
                    size="lg"
                    onChange={(e) => setUsername(e.target.value)}
                    required
                    className="form-control-lg ps-5"
                  />
                </div>

                <div className="mb-4 position-relative">
                  <FaLock className="input-icon" />
                  <MDBInput
                    wrapperClass="mb-0"
                    label="Contraseña"
                    id="password"
                    size="lg"
                    onChange={(e) => setPassword(e.target.value)}
                    type="password"
                    required
                    className="form-control-lg ps-5"
                  />
                </div>

                <MDBBtn 
                  color="primary" 
                  className="w-100 py-3 mb-3 fw-bold fs-5" 
                  type="submit"
                  disabled={isLoading}
                >
                  {isLoading ? 'Ingresando...' : (
                    <>
                      Ingresar <FaArrowRight className="ms-2" />
                    </>
                  )}
                </MDBBtn>

                <div className="text-center">
                  <a href="#/PasswordRecovery" className="text-decoration-none fs-5">
                    <FaQuestionCircle className="me-2" />
                    Olvidé mi contraseña
                  </a>
                </div>

                {showErrorAlert && (
                  <Alert variant="danger" className="d-flex align-items-center mt-3 fs-5">
                    <FaQuestionCircle className="me-2" />
                    <span>Error de autenticación</span>
                  </Alert>
                )}
              </form>
            )}
          </div>
        </MDBCol>

        {/* Right Panel - Ebro */}
        <MDBCol lg={4} className="d-none d-lg-flex right-panel align-items-center">
          <div className="w-100 p-5">
            <div className="text-center mb-5">
              <h3 className="mb-3 fw-bold">Aviso</h3>
              <p className="fs-5">
                Este portal está destinado exclusivamente<br />
                a usuarios registrados para la gestión de reservas.<br />
                Use sus credenciales para acceder.
              </p>
            </div>
            
            <div className="d-flex justify-content-center mt-5">
              <img
                src={LOGOEBRO}
                alt="Logo Ebro"
                className="brand-logo"
                style={{ width: '220px' }}
              />
            </div>
          </div>
        </MDBCol>
      </MDBRow>

      <style jsx>{`
        .login-container {
          background-color: #f8f9fa;
        }
        .left-panel {
          background: linear-gradient(135deg, #0d47a1, #1976d2);
          color: white;
        }
        .right-panel {
          background: linear-gradient(135deg, #6c757d, #495057);
          color: white;
        }
        .brand-logo {
          height: auto;
          filter: brightness(0) invert(1);
        }
        .login-form-container {
          background: white;
          border-radius: 12px;
          box-shadow: 0 5px 20px rgba(0,0,0,0.1);
        }
        .input-icon {
          position: absolute;
          left: 18px;
          top: 50%;
          transform: translateY(-50%);
          color: #6c757d;
          z-index: 10;
        }
        .feature-icon {
          width: 40px;
          height: 40px;
          background: rgba(255,255,255,0.2);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .form-control-lg {
          padding-left: 45px !important;
        }
      `}</style>
    </MDBContainer>
  );
}

export default Login;